import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	ariaLabelForSelect: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ariaLabelForSelect: {
		id: 'issue-field-select-with-analytics.ariaLabel',
		defaultMessage: 'Select Field',
		description: 'ariaLabel for select field',
	},
});
export default messages;
